import {RepeatsHttp} from "../../../http/RepeatsHttp";

export default {
    async setRepeats({commit}) {
        const repeats = await RepeatsHttp.getAllRepeats().then(result => result.data);
        commit('setRepeats', repeats);
    },
    async setUpcomingRepeats({commit}) {
        const repeats = await RepeatsHttp.getUpcomingRepeats().then(result => result.data);
        commit('setUpcomingRepeats', repeats);
    },
    setActiveRepeat({commit}, activeRepeat) {
        commit('setActiveRepeat', activeRepeat);
    },
    setManageRepeatDialog({commit}, status) {
        commit('setManageRepeatDialog', status);
    },
    setManageDeleteRepeatDialog({commit}, status) {
        commit('setManageDeleteRepeatDialog', status);
    },
    setUpcomingRepeatsDialog({commit}, status) {
        commit('setUpcomingRepeatsDialog', status);
    }
}
